import { render, staticRenderFns } from "./TypographyTables.vue?vue&type=template&id=2f17bc68&"
import script from "./TypographyTables.vue?vue&type=script&lang=js&"
export * from "./TypographyTables.vue?vue&type=script&lang=js&"
import style0 from "./TypographyTables.vue?vue&type=style&index=0&id=2f17bc68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports